import { AppShell } from '../../components/AppShell/AppShell';
import { Alert, Button, Container, Form } from 'react-bootstrap';
import { Footer } from '../../components/Footer/Footer';
import { useFirebase } from '../../../contexts/FirebaseContext';
import { Redirect } from 'react-router-dom';
import { ChangeEvent, FormEvent, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleNotch } from '@fortawesome/free-solid-svg-icons';
import { Title } from '../../components/Title/Title';
import { useTranslation } from 'react-i18next';
import { useGaming } from '../../../contexts/GamingContext';
import styles from './Collaborate.module.scss';

const CollaborateComponent = () => {
  const { staticData, requestCollaboration, currentUser, userDataFmt } = useFirebase();
  const { track } = useGaming();
  const { t } = useTranslation();

  const getInitialState = () => ({
    requestType: '',
    requestBody: '',
    requestName: userDataFmt ? `${userDataFmt.profile?.formData?.nome || ''} ${userDataFmt.profile?.formData?.cognome || ''}`.trim() : '',
    requestEmail: currentUser?.email || '',
  });

  const [request, setRequest] = useState(getInitialState());
  const requestTypeOptions = [t('collaborate.labels.role1'), t('collaborate.labels.role2'), t('collaborate.labels.role3')];

  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);

  const onRequestSubmit = (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setLoading(true);
    requestCollaboration(request)
      .then((res) => {
        if (res) {
          setSuccess(true);
          setRequest(getInitialState());
          track('WORK_WITH_US', {});
        }
      })
      .catch(console.error)
      .finally(() => setLoading(false));
  };

  if (!staticData.SHOW_COLLABORATE) return <Redirect to={'/'} />;

  return (
    <AppShell>
      <div className="d-flex flex-column flex-grow-1">
        <Title>{t('labels.lavoraConNoi')}</Title>

      <Container className="flex-grow-1">
        <header className="mb-5 text-center">
          <h1 className="text-page-title">{t('labels.lavoraConNoi')}</h1>
          <p className="text-page-subtitle">{t('collaborate.labels.lavoraConNoiDescrizione', { title: process.env.REACT_APP_TITLE })}</p>
          <p className="mt-3 text-page-subtitle">{t('collaborate.labels.tiAspettiamo', { title: process.env.REACT_APP_TITLE })}</p>
        </header>

        <div className={'d-flex flex-column align-items-center'}>
          {success && (
            <Alert variant={'success'} className={'text-center'} style={{ width: '100%', maxWidth: '500px' }}>
              {t('collaborate.labels.richiestaInviata')}
            </Alert>
          )}

          <Form className={`form-page form-page--xl ${styles.form}`} onSubmit={onRequestSubmit}>
            <div className={styles.fields}>
              <div className={styles.shortFields}>
                <Form.Group>
                  <Form.Control
                    as={'select'}
                    custom
                    required
                    disabled={loading}
                    value={request.requestType}
                    onChange={(e: ChangeEvent<HTMLSelectElement>) => setRequest({ ...request, requestType: e.target.value })}
                  >
                    <option disabled value={''}>
                      {t('collaborate.labels.seiUn')}
                    </option>
                    {requestTypeOptions.map((type) => (
                      <option key={type} value={type}>
                        {type}
                      </option>
                    ))}
                  </Form.Control>
                </Form.Group>

                <Form.Group>
                  <Form.Control
                    required
                    disabled={loading}
                    value={request.requestName}
                    onChange={(e) => setRequest({ ...request, requestName: e.target.value })}
                    placeholder={t('collaborate.labels.placeholderNome')}
                  />
                </Form.Group>

                <Form.Group>
                  <Form.Control
                    required
                    type={'email'}
                    disabled={loading}
                    value={request.requestEmail}
                    onChange={(e) => setRequest({ ...request, requestEmail: e.target.value })}
                    placeholder={t('labels.email')}
                  />
                </Form.Group>
              </div>

              <div className={styles.messageField}>
                <Form.Group>
                  <Form.Control
                    as={'textarea'}
                    required
                    rows={6}
                    value={request.requestBody}
                    onChange={(e) => setRequest({ ...request, requestBody: e.target.value })}
                    placeholder={t('collaborate.labels.placeholderRichiesta')}
                    disabled={loading}
                  />
                </Form.Group>
              </div>
            </div>
            <div className={'d-flex justify-content-end'}>
              <Button type={'submit'} variant={'primary'} disabled={loading}>
                <FontAwesomeIcon spin={loading} icon={loading ? faCircleNotch : null} className={'mr-2'} />
                {loading ? t('labels.invioInCorso') : t('labels.invia')}
              </Button>
            </div>
          </Form>
        </div>
      </Container>

      <Footer />
      </div>
    </AppShell>
  );
};

export default CollaborateComponent;
